import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { DatepickerMonthlyAdapter } from '../../utils/datepicker-month-adapter';
import { DatepickerRange } from '../../utils/datepicker-range';
const MonthsMatrixWrapper = styled.div `
  padding: 15px;
  display: flex;
  flex-flow: row wrap;
`;
const Month = styled.div `
  width: calc(100% / 3);
  padding: 10px 0;
  cursor: pointer;
  text-align: center;
  &:hover { text-decoration: underline; }
  ${props => props.selected ? 'font-weight: 800' : ''};
  ${props => props.disabled ? 'pointer-events: none;opacity: .5;' : ''};
`;
export const MonthsMatrix = (props) => {
    const [calendarAdapter, setCalendarAdapter] = useState(null);
    const MONTHS = ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'];
    const handleMonthChange = (month) => {
        if (props.onChange) {
            props.onChange(month, DatepickerRange.MONTH);
        }
    };
    useEffect(() => {
        setCalendarAdapter(new DatepickerMonthlyAdapter(props.datepicker));
    }, []);
    return calendarAdapter && React.createElement(MonthsMatrixWrapper, null, MONTHS.map((month, i) => (React.createElement(Month, { key: i, selectable: true, disabled: !calendarAdapter.canBeSelected(i), selected: calendarAdapter.isMonthSelected(i), onClick: () => handleMonthChange(i) }, month))));
};
